module.exports = __webpack_public_path__ + "img/frame (158).3b288a0b.jpg";